import React from "react";

import usersApp from "../../Images/usersApp.png";

import GooglePlay from "../../Images/GooglePlay";
import AppStore from "../../Images/AppStore";
import { motion } from "framer-motion";

const DownloadApp = () => {
  return (
    <footer className=" max-w-7xl mx-auto   sm:px-6 lg:px-8">
      <div className="bg-download overflow-y-clip   flex flex-col md:flex-row justify-around items-center w-full border md:rounded-3xl rounded-t-3xl  px-10 pt-10">
        <div className="space-y-2 flex items-center md:items-start  flex-col  ">
          <motion.h1
            initial={{
              y: 100,
              opacity: 0,
            }}
            whileInView={{ y: 0, x: 0, opacity: 1 }}
            transition={{ duration: 1, stiffnes: 1000, velocity: -100 }}
            className=" md:text-6xl text-3xl font-bold "
          >
            <span className="text-nowrap">Download the app now!</span>
          </motion.h1>
          <motion.p
            initial={{
              y: 100,
              opacity: 0,
            }}
            whileInView={{ y: 0, x: 0, opacity: 1 }}
            transition={{ duration: 2, stiffnes: 1000, velocity: -100 }}
            className=" text-primary  text-lg font-medium"
          >
            Experience seamless online booking also on the Servicing-rendering
            app
          </motion.p>

          <div className="flex items-center pt-5 space-x-5">
            <a
              href="https://play.google.com/apps/testing/com.service.rendering"
              target="_blank"
              rel="noreferrer"
            >
              <GooglePlay />
            </a>
            <a
              href="https://play.google.com/apps/testing/com.service.rendering"
              rel="noreferrer"
            >
              <AppStore />
            </a>
          </div>
        </div>

        <div className="mt-14 overflow-y-clip ">
          <motion.img
            initial={{
              y: 350,
            }}
            whileInView={{ y: 0 }}
            transition={{ duration: 1, stiffnes: 1000, velocity: -100 }}
            src={usersApp}
            className="w-72  h-auto "
            alt=""
          />
        </div>
      </div>
    </footer>
  );
};

export default DownloadApp;
